import React, { useEffect, useRef, useState } from 'react';
import socket from '../../utils/examSocket';

export default function StudentExam({ studentId, name, setCameraOn }) {
  const videoRef = useRef(null);
  const peerRef = useRef(null);
  const streamRef = useRef(null);

  const [status, setStatus] = useState('Starting...');

  useEffect(() => {
    init();

    socket.emit('student:join', {
      studentId,
      name,
    });

    socket.on('webrtc:start', async ({ adminSocketId }) => {
      setStatus('Admin requested stream');
      await createOffer(adminSocketId);
    });

    socket.on('webrtc:answer', async ({ answer }) => {
      await peerRef.current.setRemoteDescription(answer);
      setStatus('Connected to admin');
    });

    socket.on('webrtc:ice-candidate', async ({ candidate }) => {
      if (candidate) {
        await peerRef.current.addIceCandidate(candidate);
      }
    });

    return () => socket.disconnect();
  }, []);

  // --------------------------
  // START CAMERA
  // --------------------------
  const init = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true,
      });

      setCameraOn(true);
      streamRef.current = stream;

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }

      setStatus('Camera started');
    } catch (err) {
      console.error(err);
      setStatus('Camera error');
      console.error('Camera error:', err);

      if (err.name === 'NotAllowedError') {
        setCameraOn(false);

        alert(
          'Camera permission is required. Please allow camera access in your browser and try again.'
        );
      } else if (
        err.name === 'NotFoundError' ||
        err.name === 'NotReadableError'
      ) {
        setCameraOn(true);
      } else {
        setCameraOn(false);
      }
    }
  };

  // --------------------------
  // CREATE OFFER
  // --------------------------
  const createOffer = async (adminSocketId) => {
    const peer = new RTCPeerConnection({
      iceServers: [{ urls: 'stun:stun.l.google.com:19302' }],
    });

    peerRef.current = peer;

    streamRef.current.getTracks().forEach((track) => {
      peer.addTrack(track, streamRef.current);
    });

    peer.onicecandidate = (event) => {
      if (event.candidate) {
        socket.emit('webrtc:ice-candidate', {
          target: adminSocketId,
          candidate: event.candidate,
        });
      }
    };

    const offer = await peer.createOffer();
    await peer.setLocalDescription(offer);

    socket.emit('webrtc:offer', {
      offer,
      adminSocketId,
      studentSocketId: socket.id,
      studentId,
    });

    setStatus('Sending stream to admin...');
  };

  return (
    <div>
      <p>Status: {status}</p>

      <video
        ref={videoRef}
        autoPlay
        playsInline
        muted
        style={{ width: '400px', border: '1px solid black' }}
      />
    </div>
  );
}
